// This are the extensions we support, no need to have any other for now
//
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
import { SUPPORTED_TYPES } from '../constants';

export const isSupportedMimeType = (mimeType: string | undefined): boolean => {
  return !!mimeType && SUPPORTED_TYPES.includes(mimeType);
};
